import { render, staticRenderFns } from "./ModalNewMessage.vue?vue&type=template&id=7ad0b83f&scoped=true"
import script from "./ModalNewMessage.vue?vue&type=script&lang=js"
export * from "./ModalNewMessage.vue?vue&type=script&lang=js"
import style0 from "./ModalNewMessage.vue?vue&type=style&index=0&id=7ad0b83f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ad0b83f",
  null
  
)

export default component.exports